import { hasValue } from '@famly/stat_ts-utils_has-value';
import { defaultDuration, defaultErrorDuration, defaultErrorExtendedDuration, defaultSuccessDuration } from './constants';
const domain = 'GLOBAL';
const getDefaultDurationForUpdateStatusEvent = (statusType, hasExtendedErrorDuration) => {
    switch (statusType) {
        case 'Success':
            return defaultSuccessDuration;
        case 'Error':
            return hasExtendedErrorDuration ? defaultErrorExtendedDuration : defaultErrorDuration;
        default:
            return defaultDuration;
    }
};
const MAX_CHARACTER_LENGTH_BEFORE_EXTENDED_ERROR_DURATION = 80;
const shouldHaveExtendedErrorDuration = (message) => {
    if (!hasValue(message)) {
        return false;
    }
    return message.length >= MAX_CHARACTER_LENGTH_BEFORE_EXTENDED_ERROR_DURATION;
};
const createGlobalEventActions = (createAction) => {
    const { action: updateError } = createAction(`${domain}/UPDATE_GLOBAL_STATUS`, (message, sticky = false, duration = shouldHaveExtendedErrorDuration(message) ? defaultErrorExtendedDuration : defaultErrorDuration, e2eId = '') => ({
        message,
        statusType: 'Error',
        e2eId,
        sticky,
        duration,
    }));
    const { action: updateSuccess } = createAction(`${domain}/UPDATE_GLOBAL_STATUS`, (message, sticky = false, duration = defaultSuccessDuration, e2eId = '') => ({
        message,
        statusType: 'Success',
        e2eId,
        sticky,
        duration,
    }));
    const { action: updateInfo } = createAction(`${domain}/UPDATE_GLOBAL_STATUS`, (message, sticky = false, duration = defaultDuration, e2eId = '') => ({
        message,
        statusType: 'Info',
        e2eId,
        sticky,
        duration,
    }));
    const { action: updateStatus } = createAction(`${domain}/UPDATE_GLOBAL_STATUS`, (message, statusType, sticky = false, duration = getDefaultDurationForUpdateStatusEvent(statusType, shouldHaveExtendedErrorDuration(message)), e2eId = '') => ({
        message,
        statusType,
        e2eId,
        sticky,
        duration,
    }));
    const { action: clearStatus } = createAction(`${domain}/CLEAR_STATUS`, (eventId) => ({ eventId }));
    return {
        updateError,
        updateSuccess,
        updateInfo,
        updateStatus,
        clearStatus,
    };
};
export default createGlobalEventActions;
